RivalIQ.module('apps', function (apps, App, Backbone, Marionette, $, _) {

    'use strict';

    const app = apps.AccountSettings = window.createMarionetteApp();
    app.name = 'AccountSettings';

    app.addRegions({
        subscription: '#subscription',
        paymentEntry: '#payment-entry'
    });

    app.on('start', function () {
        Backbone.history.start({
            root: '/manage'
        });
    });
});
